import api from '@/services/api';
import { extractMeta } from './smr-admin';
import type {
    AddOnGroupRecord,
    AddOnGroupListParams,
    AddOnGroupsPage,
    StoreAddOnGroupPayload,
} from './addonGroup.types';

const path = '/smr/addon-groups';

export const fetchAddOnGroups = async (params: AddOnGroupListParams = {}): Promise<AddOnGroupsPage> => {
    const response = await api.get(path, { params });
    const raw = response.data as Record<string, unknown>;
    return {
        data: (raw.data ?? []) as AddOnGroupRecord[],
        meta: extractMeta(raw),
    };
};

export const fetchAddOnGroup = async (id: string): Promise<AddOnGroupRecord> =>
    ((await api.get(`${path}/${id}`)).data.data) as AddOnGroupRecord;

export const createAddOnGroup = async (payload: StoreAddOnGroupPayload): Promise<AddOnGroupRecord> =>
    ((await api.post(path, payload)).data.data) as AddOnGroupRecord;

export const updateAddOnGroup = async (id: string, payload: Partial<StoreAddOnGroupPayload>): Promise<AddOnGroupRecord> =>
    ((await api.put(`${path}/${id}`, payload)).data.data) as AddOnGroupRecord;

export const retireAddOnGroup = async (id: string): Promise<AddOnGroupRecord> =>
    ((await api.patch(`${path}/${id}/retire`)).data.data) as AddOnGroupRecord;

export const deleteAddOnGroup = async (id: string): Promise<void> => {
    await api.delete(`${path}/${id}`);
};
